import { db } from './config';
import { collection, addDoc, getDocs, doc, updateDoc, deleteDoc, query, /* orderBy, */ where } from 'firebase/firestore';

const COLLECTION_NAME = 'testimonials';

// Save a new testimonial
export const saveTestimonial = async (testimonialData) => {
  try {
    const newTestimonial = {
      ...testimonialData,
      approved: false,
      createdAt: new Date().toISOString()
    };
    
    const docRef = await addDoc(collection(db, COLLECTION_NAME), newTestimonial);
    return { id: docRef.id, ...newTestimonial };
  } catch (error) {
    console.error('Error saving testimonial:', error);
    throw error;
  }
};

// Get all testimonials (for admin)
export const getAllTestimonials = async () => {
  try {
    const testimonialsCollection = collection(db, COLLECTION_NAME);
    // Get all testimonials without using orderBy in the query
    const testimonialsQuery = query(testimonialsCollection);
    const querySnapshot = await getDocs(testimonialsQuery);
    
    const testimonials = [];
    querySnapshot.forEach((doc) => {
      testimonials.push({ id: doc.id, ...doc.data() });
    });
    
    // Sort the results in memory instead of using orderBy in the query
    return testimonials.sort((a, b) => {
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
  } catch (error) {
    console.error('Error retrieving testimonials:', error);
    return [];
  }
};

// Get approved testimonials (for public display)
export const getApprovedTestimonials = async () => {
  try {
    const testimonialsCollection = collection(db, COLLECTION_NAME);
    // Using only the where clause without orderBy to avoid requiring a composite index
    const testimonialsQuery = query(
      testimonialsCollection, 
      where('approved', '==', true)
    );
    const querySnapshot = await getDocs(testimonialsQuery);
    
    const testimonials = [];
    querySnapshot.forEach((doc) => {
      testimonials.push({ id: doc.id, ...doc.data() });
    });
    
    // Sort the results in memory instead of using orderBy in the query
    return testimonials.sort((a, b) => {
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
  } catch (error) {
    console.error('Error retrieving approved testimonials:', error);
    return [];
  }
};

// Update testimonial approval status
export const updateTestimonialStatus = async (id, approved) => {
  try {
    const testimonialRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(testimonialRef, { approved });
    return true;
  } catch (error) {
    console.error('Error updating testimonial status:', error);
    throw error;
  }
};

// Delete a testimonial
export const deleteTestimonial = async (id) => {
  try {
    const testimonialRef = doc(db, COLLECTION_NAME, id);
    await deleteDoc(testimonialRef);
    return true;
  } catch (error) {
    console.error('Error deleting testimonial:', error);
    throw error;
  }
};